export const SEARCH_TERM_KEY = 'searchTerm'

export const SEARCH_HISTORY_KEY = 'previousSearches'

export const ASSETS_ENDPOINT = 'https://assets.ur.se'

export const MINORITY_LANGUAGES = [
  'finska',
  'samiska',
  'romani',
  'jiddisch',
  'meankieli',
]

const TWO_MINUTES_IN_SECONDS = 120
const ONE_YEAR_IN_SECONDS = 31535880

export const DEFAULT_CACHE_CONTROL = `s-maxage=${TWO_MINUTES_IN_SECONDS}, stale-while-revalidate=${ONE_YEAR_IN_SECONDS}`
